import { Component } from '@angular/core'
import { randomInt } from '../../util'
import { CardComponent } from '../card'
import { ILLUSTRATION_ASSET_PATH } from '../illustration'
import { TooltipModule } from '../tooltip'
import { Spacing } from '../util'

const QUOTES = [
  'My name is Tippy!',
  'This is a tooltip that can be triggered by the Konami code.',
  'TRM stands for "The Record Media".',
  'The Konami Code was invented by Kazuhisa Hashimoto in 1985.',
  'I first existed in the FTR Gold Suite of products',
  'FTR has a special bus! But no one seems to ride it.',
  'What did the TRM say to the RTX file? Give me 5.',
  'Justice Cloud Recorder is fast, but not as fast as the Flash.',
  'For The Record delivers fast, secure access to the court record',
  'That Dihydrogen Monoxide (DHMO) is vital to your health! Please stay hydrated.',
  'FTR has been in the industry for over 30 years.',
]

@Component({
  selector: 'ftr-tippy',
  templateUrl: './tippy.component.html',
  styleUrls: ['./tippy.component.css'],
  imports: [TooltipModule, CardComponent],
})
export class TippyComponent {
  protected readonly spacing = Spacing

  quote = this.getRandomQuote()

  nextQuote(): void {
    this.quote = this.getRandomQuote()
  }

  getRandomQuote(): string {
    return QUOTES[randomInt(0, QUOTES.length - 1)]
  }

  sourcePath(): string {
    return `${ILLUSTRATION_ASSET_PATH}/tippy.png`
  }
}
